import React from 'react';

const Calendar: React.FC = () => {
  return (
    <svg viewBox="0 0 46 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.23001 0H12.05V8.59H9.23001V0ZM36.75 8.59H34.04V0H36.75V8.59ZM45.36 14.51L0.0900098 14.91L0.0100098 3.86H7.01001L6.99001 9.97H14.27L14.6 3.86H31.23L31.56 9.97H38.85L38.83 3.86H45.17L45.36 14.51ZM45.41 17.5L46 50L0.32001 48.25L0.10001 16.74L45.41 17.5ZM13.89 40.85V33.85H6.89001V40.85H13.89ZM13.89 29.11V22.11H6.89001V29.11H13.89ZM26.42 40.85L26.47 33.85H19.42V40.85H26.42ZM26.42 29.11L26.47 22.11H19.42V29.11H26.42ZM38.94 40.85V33.85H31.94V40.85H38.94ZM38.94 29.11V22.11H31.94V29.11H38.94Z" />
    </svg>
  );
};

export { Calendar };
